import React from "react";
import ultraLogo from "../../assets/logo.png";
import loginBg from "../../assets/login_image.png";
import { Button } from "../../components/button/Button";
import { Colors } from "../../utils/colors";
import { Strings } from "../../utils/strings";
import { useNavigate } from "react-router-dom";
import { isIOS } from "react-device-detect";
import "./GetStarted.css";
import { useWindowWidth } from "../../hooks/useWindowWidth";

type props = {};

export const GetStarted: React.FC<props> = () => {
  const navigate = useNavigate();
  const windowWidth = useWindowWidth();

  const buttonWidth =
    windowWidth >= 1024 ? "60%" : windowWidth >= 768 ? "80%" : "100%";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-evenly",
        width: "80%",
        height: isIOS ? "90vh" : "100vh",
        marginLeft: "auto",
        marginRight: "auto",
        maxWidth: "450px",
        // overflow: "hidden", // Disable scrolling
      }}>
      <img src={ultraLogo} alt="logo" className="logo-image" />
      <img src={loginBg} alt="login visual" className="login-image" />
      <Button
        text={Strings.LOGIN}
        onPress={() => {
          navigate("/login");
        }}
        btnStyle={{
          backgroundColor: Colors.darkBrown,
          width: buttonWidth,
          height: 48,
        }}
        textStyle={{ color: "white" }}
      />
    </div>
  );
};
